import SkeletonFilled from '../../molecules/skeleton/filled/skeleton-filled'
import SkeletonList from '../../molecules/skeleton/list/skeleton-list'
import { Grid } from '@mui/material'

const ContactsComponentShimmer = () => {
	return (
		<Grid container spacing={2} justifyContent="center">
			<Grid item xs={12}>
				<SkeletonList rows={2} />
			</Grid>
			<Grid item xs={12} sm={6}>
				<SkeletonList rows={4} height={60} />
			</Grid>
			<Grid item xs={12} sm={6}>
				<SkeletonList rows={4} height={60} />
			</Grid>
			<Grid item xs={12}>
				<SkeletonFilled width="100%" height={140} />
			</Grid>
			<Grid item xs={12} sm={6}>
				<SkeletonList rows={2} height={60} />
			</Grid>
			<Grid item xs={12} sm={6}>
				<SkeletonList rows={2} height={60} />
			</Grid>
			<Grid item xs={12} sm={6} ml="auto" mr="0">
				<SkeletonFilled height={60} />
			</Grid>
		</Grid>
	)
}

export default ContactsComponentShimmer
